<template>
  <div
    v-if="!isOnMobile"
    ref="toolbar"
    class="rounded-left rounded-lg d-none d-sm-block scroll"
    :class="{'bg-light': toolbarMode === null}"
    style="min-width: 100px"
  >
    <div
      v-if="!toolbarMode || isModalComponent"
      class="d-flex flex-column align-items-center py-4"
      style="gap: 1rem; padding-right: 10px;"
    >
      <div
        v-for="(item, index) in itemsToShow"
        :key="index"
      >
        <a-tooltip v-if="item" :getPopupContainer="tooltipContainer" placement="left">
          <template slot="title">
            {{ config[item.id]?.customization?.popoverTitle || item.title }}
          </template>
          <a-button
            size="large"
            shape="circle"
            @click="item.click(item.id)"
          >
            <a-badge
              v-if="config[item.id]?.showBadge"
              :count="config[item.id]?.badgeCount"
              :showZero="config[item.id]?.badgeShowZero"
              :title="config[item.id]?.badgeShowTitle"
              :number-style="{ backgroundColor: config[item.id]?.badgeColor || 'red' }"
            >
              <i class="mdi toolbar-item-icon" :class="item.icon"></i>
            </a-badge>
            <i v-else class="mdi toolbar-item-icon" :class="item.icon"></i>

          </a-button>
        </a-tooltip>
        <hr class="w-100" v-else>
      </div>
      <a-statistic
        v-if="config?.documentPreview?.allowSeal && !config?.documentPreview?.sealFixedLocation"
        :value="config.documentPreview.badgeCount"
        :value-style="{ color: config.documentPreview.badgeColor || 'red' }"
      >
        <template #title>
          <span>
            {{$t('seals')}}
          </span>
        </template>

        <template #suffix>
          <a-button
            type="primary"
            size="small"
            shape="circle"
            @click="onPreview"
          >
            <a-icon type="plus" />
          </a-button>
        </template>
      </a-statistic>
    </div>

    <!-- Drawers -->
    <a-drawer
      placement="right"
      width="40%"
      :closable="false"
      :visible="toolbarVisible"
      :bodyStyle="{ padding: 0 }"
    >
      <template v-for="(item, index) in itemsToRender">
        <Component
          v-if="toolbarMode === item.id"
          :class="contentClass"
          :componentId="item.id"
          :ref="item.id"
          :key="index"
          :is="item.component"
          :title="item.title"
          :icon="item.icon"
          v-bind="config[item.id]"
          @close="toolbarMode = null; toolbarVisible = false"
          v-on="$listeners"
        />
      </template>
    </a-drawer>
    <!-- <div class="h-100" :class="{ 'border rounded': isOnMobile }" v-if="toolbarMode">
      <template v-for="(item, index) in itemsToRender">
        <Component
          v-if="toolbarMode === item.id"
          :class="contentClass"
          :componentId="item.id"
          :ref="item.id"
          :key="index"
          :is="item.component"
          :title="item.title"
          :icon="item.icon"
          v-bind="config[item.id]"
          @close="toolbarMode = null"
          v-on="$listeners"
        />
      </template>
    </div> -->

    <!-- Modals -->
    <Component
      v-for="(item, index) in itemsModalToRender"
      :key="index"
      v-bind="config[item.id]"
      :is="item.component"
      :ref="item.id"
      :title="item.title"
      @close="toolbarMode = null"
      @onSealDynamicCoordinates="(event) => { $emit('onSealDynamicCoordinates', event) }"
    />
  </div>
</template>

<script>
// Components
import LmProcessHistory from './components/LmProcessHistory'
import LmComments from './components/LmComments'
import LmAllDocuments from './components/LmProcessAllDocuments'
import LmContentTemplates from './components/LmContentTemplates'
import LmProcessStatus from './components/LmProcessStatus'
import LmProcessPasses from './components/LmProcessPasses'
import LmProcessLink from './components/LmProcessLink'
import LmDocumentMovements from './components/LmDocumentMovements'
import LmDocumentPreview from './components/LmDocumentPreview'
import LmDocumentExpirationDate from './components/LmDocumentExpirationDate'
import LmDocumentModel from './components/LmDocumentModel'
import LmDocumentRecipients from './components/LmDocumentRecipients'
import LmDocumentViewers from './components/LmDocumentViewers'
import LmDocumentShareWith from './components/LmDocumentShareWith'
import LmAuditMovements from './components/LmAuditMovements'
import LmLogMovements from './components/LmLogMovements'
import LmTags from './components/LmTags'
import LmProcessGenerateZip from './components/LmProcessGenerateZip'

export default {
  inject: {
    toolbarCtx: {
      type: String,
      default: null
    }
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    toolbarHeight: {
      type: String,
      default: 'height: 700px'
    },
    contentClass: {
      type: String,
      default: 'bg-white'
    },
    items: {
      type: Array,
      defaultt: () => []
    },
    config: {
      type: Object,
      required: true
    }
  },
  components: {
    LmProcessHistory,
    LmProcessStatus,
    LmProcessPasses,
    LmProcessLink,
    LmComments,
    LmAllDocuments,
    LmContentTemplates,
    LmDocumentMovements,
    LmDocumentPreview,
    LmDocumentExpirationDate,
    LmDocumentModel,
    LmDocumentRecipients,
    LmDocumentViewers,
    LmDocumentShareWith,
    LmAuditMovements,
    LmLogMovements,
    LmTags,
    LmProcessGenerateZip
  },
  data () {
    return {
      toolbarVisible: false,
      toolbarMode: null,
      screenWidth: innerWidth
    }
  },
  watch: {
    toolbarCols: {
      immediate: true,
      handler (val) {
        if (this.screenWidth < 576) {
          val = 0
        }
        this.$emit('cols', val)
      }
    },
    toolbarMode (val) {
      this.$emit('change', val)
    },
    isOnMobile (val) {
      if (val) {
        this.$emit('cols', 0)
      } else {
        this.$emit('cols', 1)
      }
    }
  },
  computed: {
    // Hago que el cambio a mobile sea dinámico y que no haga falta recargar para que se aplique
    // https://stackoverflow.com/questions/47219272/how-can-i-use-window-size-in-vue-how-do-i-detect-the-soft-keyboard
    isOnMobile () {
      return this.screenWidth < 576
    },
    toolbarCols () {
      // Nota. oculto la toolbar en modo mobile
      if (this.toolbarMode && !this.isModalComponent) {
        return this.itemsConfig[this.toolbarMode].cols
      }
      return 1
    },
    isModalComponent () {
      if (this.toolbarMode && this.itemsConfig[this.toolbarMode].displayType === 'modal') {
        return true
      }
      return false
    },
    itemsConfig () {
      return {
        comments: {
          id: 'comments',
          icon: 'mdi-comment-text-outline',
          title: 'Comentarios',
          component: 'LmComments',
          cols: this.toolbarCtx === 'processes' ? 4 : 3,
          click: (id) => this.updateToolbarMode(id)
        },
        contentTemplates: {
          id: 'contentTemplates',
          icon: 'mdi-content-duplicate',
          title: 'Templates de contenido',
          component: 'LmContentTemplates',
          cols: this.toolbarCtx === 'processes' ? 4 : 3,
          click: (id) => this.updateToolbarMode(id)
        },
        allDocuments: {
          id: 'allDocuments',
          icon: 'mdi-file-document-outline',
          title: 'Todos los documentos',
          component: 'LmAllDocuments',
          cols: 5,
          click: (id) => this.updateToolbarMode(id)
        },
        allInternalDocuments: {
          id: 'allInternalDocuments',
          icon: 'mdi-text-box-outline',
          title: 'Todos los documentos internos',
          component: 'LmAllDocuments',
          cols: 5,
          click: (id) => this.updateToolbarMode(id)
        },
        processHistory: {
          id: 'processHistory',
          icon: 'mdi-swap-horizontal',
          title: 'Historial',
          component: 'LmProcessHistory',
          cols: 5,
          click: (id) => this.updateToolbarMode(id)
        },
        processMovements: {
          id: 'processMovements',
          icon: 'mdi-timeline-check-outline',
          title: 'Movimientos',
          component: 'LmProcessHistory',
          cols: 5,
          click: (id) => this.updateToolbarMode(id)
        },
        processPasses: {
          id: 'processPasses',
          icon: 'mdi-arrow-right-bold',
          title: 'Nuevo pase',
          component: 'LmProcessPasses',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        processStatus: {
          id: 'processStatus',
          icon: 'mdi-flag-outline',
          title: 'Nuevo estado',
          component: 'LmProcessStatus',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        processLink: {
          id: 'processLink',
          icon: 'mdi-link-variant',
          title: 'Asociar trámite',
          component: 'LmProcessLink',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        documentMovements: {
          id: 'documentMovements',
          icon: 'mdi-timeline-check-outline',
          title: 'Movimientos',
          component: 'LmDocumentMovements',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        documentPreview: {
          id: 'documentPreview',
          icon: 'mdi-text-box-search-outline',
          title: 'Vista previa',
          component: 'LmDocumentPreview',
          displayType: 'modal',
          click: (id) => {
            this.updateToolbarMode(id)
            this.onPreview()
          }
        },
        documentPreviewWithQr: {
          id: 'documentPreview',
          icon: 'mdi-qrcode',
          title: 'Vista previa (con sellos)',
          component: 'LmDocumentPreview',
          displayType: 'modal',
          click: (id) => {
            this.updateToolbarMode(id)
            this.onPreview()
          }
        },
        documentExpirationDate: {
          id: 'documentExpirationDate',
          icon: 'mdi-timer',
          title: this.$t('expiration_date'),
          component: 'LmDocumentExpirationDate',
          click: (id) => this.updateToolbarMode(id)
        },
        documentModel: {
          id: 'documentModel',
          icon: 'mdi-file-export-outline',
          title: 'Documento completo',
          component: 'LmDocumentModel',
          displayType: 'modal',
          click: (id) => {
            this.updateToolbarMode(id)
            this.$refs.documentModel[0].onPreview()
          }
        },
        documentRecipients: {
          id: 'documentRecipients',
          icon: 'mdi-file-send-outline',
          title: 'Destinatarios',
          component: 'LmDocumentRecipients',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        documentViewers: {
          id: 'documentViewers',
          icon: 'mdi-file-eye-outline',
          title: 'Visualizadores',
          component: 'LmDocumentViewers',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        documentShareWith: {
          id: 'documentShareWith',
          icon: 'mdi-share-variant-outline',
          title: 'Compartido con',
          component: 'LmDocumentShareWith',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        auditMovements: {
          id: 'auditMovements',
          icon: 'mdi-history',
          title: 'Auditoría',
          component: 'LmAuditMovements',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        logMovements: {
          id: 'logMovements',
          icon: 'mdi-lock-clock',
          title: 'Historial de Logueo',
          component: 'LmLogMovements',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        tags: {
          id: 'tags',
          icon: 'mdi-tag-multiple',
          title: 'Tags',
          component: 'LmTags',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        processGenerateZip: {
          id: 'processGenerateZip',
          icon: 'mdi-folder-zip-outline',
          title: 'Zip',
          component: 'LmProcessGenerateZip',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        }
      }
    },
    // Componentes que son modales
    itemsModalToRender () {
      return this.itemsToRender.filter(el => el?.displayType === 'modal')
    },
    // Componente a renderizar (filtro los nulls)
    itemsToRender () {
      return this.itemsToShow.filter(el => el)
    },
    // Icono a mostrar
    itemsToShow () {
      if (this.items.length) {
        return this.items.map(el => {
          if (el) {
            return { ...this.itemsConfig[el] }
          }
          return el
        })
      }
      return []
    }
  },
  methods: {
    tooltipContainer () {
      return this.$parent.$el
    },
    onScreenResize () {
      this.screenWidth = innerWidth
    },
    updateToolbarMode (id) {
      if (this.config[id]?.changesUnsaved) {
        this.$emit('onUnsavedChanges')
        return
      }

      this.toolbarMode = id
      if (!this.isModalComponent) {
        this.toolbarVisible = true
      }
    },
    async onPreview () {
      if (this.$refs?.documentPreview?.length && this.$refs?.documentPreview[0]) {
        this.$refs.documentPreview[0].onPreview()
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onScreenResize)
    this.onScreenResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onScreenResize)
  }
}
</script>

<style lang="sass" scoped>
.toolbar-float
  position: absolute
  flex: 75% 0 0
  max-width: 75%
  right: 0
  height: 85vh
  z-index: 1
  @media all and (min-width: 1024px)
    flex: 50% 0 0
    max-width: 50%
.toolbar-item-icon
  font-size: 1.2rem
.scroll
  overflow-y: auto
</style>
